import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlEmailProps extends ControlTemplateProps {
    
}

export const ControlEmail: React.FC<ControlEmailProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="email" {...ComponentProps(props)} style={{ ...styles.email ?? styles.text ?? styles.input, ...props.style }} />        
    );
};